import Vue from 'vue'

import PageLayout from '@/components/layouts/PageLayout'

Vue.component('page-layout', PageLayout)
